export const toolTypes = {
	RECTANGLE: "RECTANGLE",
	CIRCLE: "CIRCLE",
	LINE: "LINE",
	PENCIL: "PENCIL",
	TEXT: "TEXT",
	ERASER: "ERASER",
};
